import {
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
  useMemo,
} from "react";
import { useSecurityMaster } from "./SecurityMasterContext";
import axios from "axios";
import localforage from "localforage";

localforage.config({
  name: "market-cache",
  storeName: "prevClose",
});

const MarketDhanContext = createContext();
// const BASE_URL = "http://localhost:8000";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const MarketDhanProvider = ({ children }) => {
  const [data, setData] = useState({});
  const [ltpData, setLtpData] = useState("");
  const [loading, setLoading] = useState(false);
  const [securityIdData, setSecurityIdData] = useState("");
  const [securityLoading, setSecurityLoading] = useState(false);
  const [securityError, setSecurityError] = useState("");
  const {
    loadNifty50,
    loadNifty100,
    loadNiftySmallCap,
    loadNiftyBank,
    loadNiftyMidCap,
  } = useSecurityMaster();
  const [marketData, setMarketData] = useState([]);
  const [activeSymbols, setActiveSymbols] = useState([]);
  const [ohlcMap, setOhlcMap] = useState({});
  const [ltpMap, setLtpMap] = useState({});
  const [prevCloseMap, setPrevCloseMap] = useState({});
  const [activeIndex, setActiveIndex] = useState(null);
  const [quoteMap, setQuoteMap] = useState([]);
  const [nseData, setNseData] = useState();

  const getSecurityIdBySymbol = async (symbol) => {
    try {
      setSecurityLoading(true);
      setSecurityError(null);

      const response = await axios.get(`${BASE_URL}/api/securityId`, {
        params: {
          symbol,
        },
      });
      console.log("Response from data", response);

      setSecurityIdData(response.data);

      return response.data;
    } catch (err) {
      console.error("Security Fetch Error:", err.message);

      setSecurityError(
        err.response?.data?.message || "Failed to fetch security id",
      );

      return null;
    } finally {
      setLoading(false);
    }
  };

  const fetchPrevClose = async (securityId) => {
    const key = `prev_close_${securityId}`;

    // 1️⃣ Try cache
    const cached = await localforage.getItem(key);
    if (cached) {
      return cached; // number
    }

    // 2️⃣ Fetch from API
    try {
      console.log("Fetching prevClose for", securityId);

      const res = await axios.post(`${BASE_URL}/api/market-historical`, {
        securityId,
      });

      const prevClose = res.data?.prevClose ?? null;
      if (prevClose == null) return null;

      await localforage.setItem(key, prevClose);
      console.log("prevdata", res.data);
      return prevClose;
    } catch (e) {
      console.error("PrevClose API failed", securityId, e.response?.status);
      return null;
    }
  };

  //   const loadPrevCloses = async (symbols) => {
  //     if (localStorage.getItem("prevCloseLoadedToday")) return;

  //     const map = {};

  //     for (const s of symbols) {
  //       // 🔥 TEMP LIMIT (important)
  //       map[s.security_id] = await fetchPrevClose(s.security_id);
  //     }

  //     setPrevCloseMap(map);
  //     localStorage.setItem("prevCloseLoadedToday", "true");
  //   };

  //   const fetchOHLC = async ({ NSE_EQ = [] }) => {
  //     try {
  //       setLoading(true);

  //       const res = await axios.post(`${BASE_URL}/api/ohlc`, {
  //         NSE_EQ,
  //       });

  //       setData(res.data);
  //       return res.data;
  //     } catch (err) {
  //       console.error("Frontend OHLC error:", err.response?.data || err.message);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   const fetchLTP = async ({ NSE_EQ = [] }) => {
  //     try {
  //       setLoading(true);

  //       const res = await axios.post(`${BASE_URL}/api/ltp`, {
  //         NSE_EQ,
  //       });

  //       setLtpData(res.data);
  //       return res.data;
  //     } catch (err) {
  //       console.error("Frontend OHLC error:", err.response?.data || err.message);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   const clearPrevCloseCache = () => {
  //     Object.keys(localStorage).forEach((key) => {
  //       if (key.startsWith("prev_close_")) {
  //         localStorage.removeItem(key);
  //       }
  //     });
  //     localStorage.removeItem("prevCloseLoadedToday");
  //   };
  // 🔴 CHANGED: clear IndexedDB (localforage), not localStorage
  const loadPrevCloses = async (symbols) => {
    console.log("loadPrevCloses called with", symbols?.length); // 🔴 DEBUG

    if (!symbols?.length) {
      console.warn("loadPrevCloses aborted: no symbols");
      return;
    }

    const map = {};

    for (const s of symbols) {
      console.log("Fetching prevClose for", s.security_id); // 🔴 DEBUG
      map[Number(s.security_id)] = await fetchPrevClose(s.security_id);
    }

    console.log("prevCloseMap built:", map); // 🔴 DEBUG
    setPrevCloseMap(map);
  };
  const fetchNseIndices = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/api/nse-indices`);
      setNseData(response.data);
      console.log("Response from nse indixes", response.data);
    } catch (err) {
      console.log("Error is ", err.message);
      setLoading(false);
    }
  };

  const clearPrevCloseCache = async () => {
    const keys = await localforage.keys();

    for (const key of keys) {
      if (key.startsWith("prev_close_")) {
        await localforage.removeItem(key);
      }
    }

    setPrevCloseMap({});
  };

  //     let symbols;
  //     if (text === "nifty50") {
  //       symbols = await loadNifty50();

  //       setActiveSymbols(symbols);
  //       console.log("SYmbols", symbols);
  //     } else if (text === "nifty100") {
  //       symbols = await loadNifty100();
  //       setActiveSymbols(symbols);
  //       console.log("SYmbols", symbols);
  //     } else if (text === "niftysmallcap") {
  //       symbols = await loadNiftySmallCap();
  //       setActiveSymbols(symbols);
  //       console.log("Symbols", symbols);
  //     } else if (text === "niftybank") {
  //       symbols = await loadNiftyBank();
  //       setActiveSymbols(symbols);
  //       console.log("Symbols", symbols);
  //     }
  //   };
  // const clearPrevCloseCache = () => {
  //   Object.keys(localStorage).forEach((key) => {
  //     if (key.startsWith("prev_close_")) {
  //       localStorage.removeItem(key);
  //     }
  //   });
  // };
  // const initIndex = async (text) => {
  //   // 🔥 if index changed, reset prevClose cache
  //   if (text !== activeIndex) {
  //     clearPrevCloseCache();
  //     setPrevCloseMap({});
  //     localStorage.removeItem("prevCloseLoadedToday");
  //   }

  //   setActiveIndex(text);

  //   let symbols;
  //   if (text === "nifty50") symbols = await loadNifty50();
  //   else if (text === "nifty100") symbols = await loadNifty100();
  //   else if (text === "niftysmallcap") symbols = await loadNiftySmallCap();
  //   else if (text === "niftybank") symbols = await loadNiftyBank();

  //   setActiveSymbols(symbols);
  // };
  const initIndex = async (text) => {
    clearPrevCloseCache(); // ✅ THIS IS THE FIX
    console.log("text recived", text);
    let symbols;
    if (text === "nifty50") symbols = await loadNifty50();
    else if (text === "nifty100") symbols = await loadNifty100();
    else if (text === "niftysmallcap") symbols = await loadNiftySmallCap();
    else if (text === "niftybank") symbols = await loadNiftyBank();
    else if (text === "niftymidcap") symbols = await loadNiftyMidCap();

    setActiveSymbols(symbols);
  };

  const fetchOHLC = async (securityIds) => {
    const res = await axios.post(`${BASE_URL}/api/ohlc`, {
      NSE_EQ: securityIds,
    });

    return res.data?.data?.NSE_EQ || {};
  };

  const loadMarketBySymbols = async (symbols) => {
    if (!symbols?.length) return;

    setLoading(true);

    try {
      // 1️⃣ Extract security_ids
      const securityIds = symbols.map((s) => s.security_id);

      // 2️⃣ Fetch OHLC
      //   const ohlcRes = await axios.post(`${BASE_URL}/api/ohlc`, {
      //     NSE_EQ: securityIds,
      //   });
      //   console.log("ohlc data", ohlcRes.data);

      // 3️⃣ Fetch LTP
      const res = await axios.post(`${BASE_URL}/api/market-data`, {
        NSE_EQ: securityIds,
      });
      console.log("Res data", res.data);
      //   const ltpRes = await axios.post(`${BASE_URL}/api/ltp`, {
      //     NSE_EQ: securityIds,
      //   });
      //   console.log("ltp data", ltpRes.data);

      //   //   const ohlcMap = ohlcRes?.data?.data?.NSE_EQ || {};
      //   const ltpMap = ltpRes?.data?.data?.NSE_EQ || {};

      // 4️⃣ Build symbol map
      const symbolMap = {};
      symbols.forEach((s) => {
        symbolMap[s.security_id] = s.symbol;
      });

      // 5️⃣ Merge everything
      //   const merged = Object.keys(ltpMap).map((sid) => {
      //     const ohlc = ohlcMap[sid]?.ohlc || {};
      //     const close = ohlc?.close ?? null;
      //     const ltp = ltpMap[sid];

      //     return {
      //       security_id: Number(sid),
      //       symbol: symbolMap[sid],
      //       last_price: ltp,
      //       open: ohlc?.open,
      //       high: ohlc?.high,
      //       low: ohlc?.low,
      //       close,
      //       percent_change:
      //         close && ltp ? +(((ltp - close) / close) * 100).toFixed(2) : null,
      //     };
      //   });

      //   setMarketData(merged);
      //   return merged;
    } catch (err) {
      console.error("Market load error:", err.message);
    } finally {
      setLoading(false);
    }
  };
  const loadNifty50Market = async () => {
    const symbols = await loadNifty50();
    await loadMarketBySymbols(symbols);
  };

  console.log("active symbols", activeSymbols);

  //   const loadOHLCOnce = async () => {
  //     const ids = activeSymbols.map((s) => s.security_id);

  //     const res = await axios.post(`${BASE_URL}/api/ohlc`, {
  //       NSE_EQ: ids,
  //     });

  //     const ohlc = res?.data?.data?.NSE_EQ || {};
  //     setOhlcMap(ohlc);

  //     // 🔥 THIS IS THE KEY LINE
  //     // const prevMap = storePrevCloseFromOHLC(ohlc);
  //     // setPrevCloseMap(prevMap);
  //   };

  console.log("ltpmap", ltpMap);
  console.log("ohlcmap", ohlcMap);
  const getPrevClose = (sid) => {
    const raw = localforage.getItem(`prev_close_${sid}`);
    if (!raw) return null;

    try {
      const parsed = JSON.parse(raw);
      return parsed.close ?? null;
    } catch {
      return null;
    }
  };
  const symbolMap = useMemo(() => {
    const map = {};
    activeSymbols?.forEach((s) => {
      map[String(s.security_id)] = s.symbol;
    });
    return map;
  }, [activeSymbols]);
  const fetchMarketQuotes = async () => {
    const ids = activeSymbols.map((s) => s.security_id);
    if (!ids.length) return;

    setLoading(true);

    try {
      const res = await axios.post(`${BASE_URL}/api/market-quote`, {
        NSE_EQ: ids,
      });

      // Dhan returns { data: { NSE_EQ: { securityId: {...} } } }
      console.log("response from quote", res.data);
      const quoteData = res.data?.data?.NSE_EQ || {};
      setQuoteMap(quoteData);
      console.log("quoteData", quoteData);
      return quoteData;
    } catch (e) {
      console.error("Market Quote fetch failed", e.response?.data || e.message);
    } finally {
      setLoading(false);
    }
  };
  console.log("Previosu map", prevCloseMap);
  console.log("Uqote data", quoteMap);
  //   useEffect(() => {
  //     if (!Object.keys(ohlcMap).length) return;

  //     const merged = Object.keys(ohlcMap).map((sid) => {
  //       const ohlc = ohlcMap[sid];
  //       //   const prevClose = getPrevClose(sid);
  //       const key = Number(sid); // 🔴 FIX: normalize key

  //       const prevClose = Object.prototype.hasOwnProperty.call(prevCloseMap, key)
  //         ? prevCloseMap[key]
  //         : null;

  //       //   const prevClose = prevCloseMap[sid];
  //       console.log("prev close", prevClose);
  //       //   const prevClose = getPrevClose(sid);
  //       const last_price = ohlc?.last_price;

  //       //   console.log("prevClose", sid, prevClose);

  //       return {
  //         security_id: Number(sid),
  //         symbol: symbolMap[sid] ?? null,
  //         open: ohlc?.ohlc?.open,
  //         high: ohlc?.ohlc?.high,
  //         low: ohlc?.ohlc?.low,
  //         // close: prevClose,
  //         close: ohlc?.ohlc?.close,
  //         last_price,
  //         // percent_change:
  //         //   prevClose && last_price
  //         //     ? +(((last_price - prevClose) / prevClose) * 100).toFixed(2)
  //         //     : null,
  //         percent_change:
  //           prevClose != null && last_price != null
  //             ? +(((last_price - prevClose) / prevClose) * 100).toFixed(2)
  //             : null,
  //       };
  //     });

  //     setMarketData(merged);
  //   }, [ohlcMap, prevCloseMap]);
  useEffect(() => {
    if (!Object.keys(quoteMap).length) return;

    const merged = Object.keys(quoteMap).map((sid) => {
      const quote = quoteMap[sid];
      const key = Number(sid);
      const last_price = quote.last_price ?? null;
      const prev_close = quote?.ohlc?.close ?? null;
      return {
        security_id: key,
        symbol: symbolMap[sid] ?? null,

        // 🔥 Prices
        last_price: last_price,
        prev_close: prev_close,

        // 🔥 OHLC
        open: quote?.ohlc?.open ?? null,
        high: quote?.ohlc?.high ?? null,
        low: quote?.ohlc?.low ?? null,

        // 🔥 Change (DIRECT FROM DHAN)
        net_change: quote.net_change ?? null,
        volume: quote?.volume,
        percent_change:
          prev_close != null && last_price != null
            ? +(((last_price - prev_close) / prev_close) * 100).toFixed(2)
            : null,
      };
    });

    setMarketData(merged);
  }, [quoteMap, symbolMap]);

  useEffect(() => {
    if (!activeSymbols?.length) return;

    // 1️⃣ OHLC once per symbol set
    // loadOHLCOnce();
    // loadPrevCloses(activeSymbols);
    fetchMarketQuotes();
    fetchNseIndices();
  }, [activeSymbols]);

  return (
    <MarketDhanContext.Provider
      value={{
        data,
        loading,
        fetchOHLC,
        loadNifty50Market,
        marketData,
        loadMarketBySymbols,
        // loadNifty100Market,
        // fetchLTP,
        ltpData,
        initIndex,
        nseData,
        getSecurityIdBySymbol,
        securityIdData,
        securityError,
        securityLoading,
      }}
    >
      {children}
    </MarketDhanContext.Provider>
  );
};

export const useMarket = () => useContext(MarketDhanContext);
